module.exports = __webpack_public_path__ + "static/img/headBg_1.ec837e75.png";